<template>
    <div>
      <hp5-semantic size-selection="xs">
        <span><hp5-heading size-selection="xxs" tag-selection="h4">Specialties: </hp5-heading></span>
        <span class="align">{{ specialty }}</span>
      </hp5-semantic>
    </div>
</template>

<script setup>
 
    const props = defineProps({
        result: Object
    })

    const specialty = computed(() => props.result.practicingSpecialty)

</script>

<style lang="scss" scoped>
@use '../../../../assets/scss/breakpoints' as *;
  
  div {
    display: flex;
  }
  span {
    float: left;
    margin-right: var(--spacing-xxs);
  }
  @include small-up {
    .align {
      margin-top: 1px;
    }
  }
</style>